<div style="padding: 1cm;">

  <!-- Top Buttons -->
  <div style="display: flex; justify-content: flex-end; gap: 12px; margin-bottom: 20px;" class="noPrint">

    <!-- Debug Info (remove after fix) -->
    <span style="font-size: 12px; color: gray; align-self: center;">
      Total Labels: {{ data1?.length || 0 }} / Raw: {{ labelsData?.length || 0 }}
    </span>

    <button
      mat-raised-button
      color="primary"
      style="font-size: 14px; font-weight: 600;"
      printTitle="Label"
      printSectionId="print-section"
      ngxPrint>
      Print
    </button>

    <button mat-raised-button (click)="close()" class="noPrint" style="font-size: 14px; font-weight: 600;">
      Close
    </button>
  </div>

  <!-- Printable Section -->
  <div id="print-section" style="background-color: white; padding: 1cm; margin-left: 100px; width: 100%;">

    <!-- Header -->
    <div style="margin-bottom: 10px; font-weight: bold; font-size: 14px; color: black;">

      <!-- <span *ngIf="repNames" style="margin-right: 20px;">
        <div>प्रतिनिधी पासून - {{ firstRepName }}</div>
        <div>प्रतिनिधी पर्यंत - {{ lastRepName }}</div>
      </span> -->

      <!-- ✅ Distributive Rep Header -->
      <span *ngIf="distributiveRep" style="margin-right: 20px;">
        <div>वितरण प्रतिनिधी - {{ distributiveRep }}</div>
      </span>

      <span *ngIf="district?.length">
        जिल्हा - {{ district[0] }}
      </span>

      <span *ngIf="taluka?.length" style="margin-left: 20px;">
        तालुका - {{ taluka[0] }}
      </span>

      <!-- Delivery Mode -->
      <span *ngIf="deliveryMode" style="margin-left: 20px;">
        वितरण पद्धत - {{ deliveryMode }}
      </span>

    </div>

    <!-- Empty State Message -->
    <div *ngIf="data1?.length === 0"
         style="text-align: center; padding: 40px; color: red; font-size: 16px;">
      ⚠️ No label data found. Please check filters.
      <br/>
      <small style="color: gray;">Raw records received: {{ labelsData?.length || 0 }}</small>
    </div>

    <!-- Labels Grid -->
    <div style="display: flex; flex-wrap: wrap; gap: 12px;">

      <ng-container *ngFor="let item of data1; let i = index">

        <div
          *ngIf="item?.name"
          style="
            width: 22.5%;
            border: 1px solid black;
            padding: 10px;
            box-sizing: border-box;
            min-height: 135px;
            font-size: 13px;
            color: black;
            page-break-inside: avoid;
          ">

          <!-- Customer Info (only if iscustomer = yes) -->
          <div *ngIf="iscustomer === 'yes'" style="font-weight: bold; font-size: 12px; color: #555;">
            {{ item?.month }}/{{ item?.subno }} - {{ item?.year }}
          </div>

          <!-- Name + Book Copies -->
          <div style="display: flex; justify-content: space-between; align-items: center; width: 100%; font-weight: bold;">
            <span>{{ item?.name }}</span>
            <span style="font-size: 12px; white-space: nowrap;">
              प्रति: {{ item?.book_copies || 0 }}
            </span>
          </div>

          <!-- Address -->
          <div *ngIf="item?.address">{{ item?.address }}</div>

          <!-- Taluka -->
          <div *ngIf="item?.taluka">{{ item?.taluka }}</div>

          <!-- District + Pincode + State -->
          <div>
            <span *ngIf="item?.district">{{ item?.district }}</span>
            <span *ngIf="item?.pincode && item?.pincode != '0'">
              - {{ item?.pincode }}
            </span>
            <span *ngIf="item?.state"> {{ item?.state }}</span>
          </div>

          <!-- Mobile -->
          <div *ngIf="item?.mobile_no">
            📞 {{ item?.mobile_no }}
          </div>

        </div>

      </ng-container>

    </div>

  </div>
</div>
